import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';

export function useToggleFileFavouriteMutation() {
  const queryClient = useQueryClient();

  const { mutateAsync: toggleFavourite, isLoading } = useMutation(
    ({ id, isFavourite }: { id: string; isFavourite: boolean }) =>
      isFavourite ? API_HANDLERS.FILES.REMOVE_FAVOURITE(id) : API_HANDLERS.FILES.ADD_FAVOURITE(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['files']);
      },
    },
  );

  return { toggleFavourite, isLoading };
}
